import React, { Component } from 'react'
import moment from 'moment'

class UpdateFromPacer extends Component {
    render () {
        let pacerReceiptMarkup;
        const { pacerUpdateHandler, pacerReceipt, lastUpdated } = this.props;

        if (pacerReceipt) pacerReceiptMarkup = this.getPacerUpdateReceipt(pacerReceipt);

        return (
            <div>
                { pacerReceiptMarkup }
                <div className="ir-search-refresh">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="ir-search-refresh-link">
                                        <a href="#" className="form-submit green" onClick={ pacerUpdateHandler }>
                                                Update&nbsp;from&nbsp;PACER</a>
                                        &nbsp;
                                      <abbr title="Please note you will be charged 10 cents per page">
                                        10&cent;/page
                                      </abbr>
                                    </div>
                                </td>
                                <td>
                                    <div className="ir-search-refresh-date">
                                        Last updated: {lastUpdated ? (
                                            moment(parseInt(lastUpdated * 1000)).format("M/D/YYYY h:mm A")
                                        ) : 'n/a'}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    getPacerUpdateReceipt = (params) => {

        const { datetime, user_id, client_code, description, criteria, pages, cost } = params

        return (
            <div className='ir-search-receipt'>
                <table>
                    <thead>
                    <tr>
                        <th colSpan="2">PACER Service Center</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>Receipt:</th>
                        <td>{ datetime }</td>
                    </tr>
                    <tr>
                        <th>User:</th>
                        <td>{ user_id }</td>
                    </tr>
                    <tr>
                        <th>Client:</th>
                        <td>{ client_code }</td>
                    </tr>
                    <tr>
                        <th>Description:</th>
                        <td>{ description }</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td>{ criteria }</td>
                    </tr>
                    <tr>
                        <th>Pages:</th>
                        <td>{ pages }&nbsp;(${ cost })</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default UpdateFromPacer



/** WEBPACK FOOTER **
 ** ./src/components/common/UpdateFromPacer.js
 **/